module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "26-01-24-AvgGas.578bd958.png";